export default __webpack_public_path__ + "static/media/agony.acd7873e.svg";